export default __webpack_public_path__ + "static/media/logo-mask.fd9e125c.svg";